import { cn } from "@utils/utils";
import styles from "./Section.module.css";
import { ReactNode } from "react";

export const Section = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div className={cn(styles.section, className)}>
    <div className={styles.container}>{children}</div>
  </div>
);
